module.exports = __webpack_public_path__ + "static/media/toll-service-pt.5e2c7935.mp4";